module.exports = __webpack_public_path__ + "img/air-transport.58d99ef5.png";